module.exports = __webpack_public_path__ + "static/media/pacientes.9055293e.jpeg";